import { render } from "./CardZero.vue?vue&type=template&id=0a230621"
import script from "./CardZero.vue?vue&type=script&lang=js"
export * from "./CardZero.vue?vue&type=script&lang=js"

import "./CardZero.vue?vue&type=style&index=0&id=0a230621&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__